const createMockFunction = () =>
  typeof jest !== 'undefined'
    ? jest.fn().mockImplementation(() => Promise.resolve({}))
    : () => Promise.resolve({ uid: 'uid' });

export const mockTitleCardApi = {
  getAll: createMockFunction(),
  get: createMockFunction(),
  create: createMockFunction(),
  update: createMockFunction(),
}
